import gql from 'graphql-tag';

export const candidateNotesQuery = gql`
  query candidateNotes($candidateId: ID!) {
    candidate(candidateId: $candidateId) {
      id
      notes {
        id
        content
        createdAt
        author {
          id
          name
          avatarUrl
        }
      }
    }
  }
`;
